import { computed, defineAsyncComponent, h, ref } from 'vue'
import { hasFeature } from '@/brand'

// Which admin panel this browser shows: the original one or admin-v2 (brands with the adminV2 feature)
const STORAGE_KEY = 'admin-panel'

const readChoice = () => {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

const choice = ref(readChoice())

const v2Enabled = computed(() => hasFeature('adminV2') && choice.value === 'v2')

const setV2 = (enabled) => {
  choice.value = enabled ? 'v2' : 'v1'
  try {
    localStorage.setItem(STORAGE_KEY, choice.value)
  } catch {
    // private mode: the choice lasts until reload
  }
}

export function useAdminPanel() {
  return {
    available: hasFeature('adminV2'),
    v2Enabled,
    setV2,
    toggle: () => setV2(!v2Enabled.value),
  }
}

/**
 * Route component of an admin page that admin-v2 has its own version of: renders the one of
 * the panel the browser shows, and swaps when the admin switches panels. Both stay lazy chunks.
 */
export function adminPage(legacy, v2) {
  const Legacy = defineAsyncComponent(legacy)
  const V2 = defineAsyncComponent(v2)

  return {
    name: 'AdminPage',
    inheritAttrs: false,
    setup(_, { attrs }) {
      return () => h(v2Enabled.value ? V2 : Legacy, attrs)
    },
  }
}
